import { useTenant } from "../../../../hooks/useTenant";
import { useReceivablesRecords } from "./useReceivablesRecords";
import { useReceivablesMutations } from "./useReceivablesMutations";

/**
 * useReceivables
 * Contas a Receber (ASSET).
 * Orquestrador S.O.L.I.D. conectando dados da tabela e service de mutação.
 */
export const useReceivables = () => {
    const { idTenant, user: authUser } = useTenant();

    // 1. Hook de Leituras, Filtros e Balanço
    const {
        records, allRecords, summary, loading, error, hasMore, loadMore, refresh,
        statusFilter, setStatusFilter, search, setSearch, startDate, setStartDate, endDate, setEndDate,
        handleSearch, hasSearched
    } = useReceivablesRecords(idTenant);

    // 2. Hook de Ações (Mutações no Banco)
    const {
        processing, markAsPaid, cancelRecord
    } = useReceivablesMutations(idTenant, authUser, refresh);

    return {
        records,
        allRecords,
        summary,
        loading,
        error,
        hasMore,
        processing,
        statusFilter,
        search,
        startDate,
        endDate,
        setStatusFilter,
        setSearch,
        setStartDate,
        setEndDate,
        handleSearch,
        hasSearched,
        actions: {
            loadMore,
            refresh,
            markAsPaid,
            cancelRecord,
        },
    };
};
